<template>
    <div>
        <div class="breadcrumb">
            <h1 style="color: #AC8400;">Banner Details</h1>
        </div>

        <!-- Breadcrumbs -->
        <div style="padding: 10px; background-color: #F2F2F2">
            <router-link to="/dashboard">Dashboard</router-link> /
            <router-link to="/banner">Banner Details</router-link> / 
            <b>Add Banner</b>
        </div>
        <!-- End of breadcrumbs -->

        <div class="separator-breadcrumb border-top"></div>

        <div class="row mb-4">
            <div class="col-md-12 mb-4">
                <!-- Card -->
                <div class="card text-left">
                    <div class="card-body">
                        <h4 class="card-title mb-3">
                            <b>Banner Details</b>
                        </h4>

                        <p>Fill in the information</p>

                        <form class = "form" @submit.prevent="handleSubmit">
                            <div class = "form-group">
                                <label>Company Name</label>
                                <input v-model="vendor.name" class="form-control" disabled>
                            </div>

                            <div class = "form-group">
                                <label>Banner Description</label>
                                <textarea class="form-control" v-model="vendor.description" placeholder="Enter Banner Description">
                                </textarea>
                            </div>

                            <div class = "form-group">
                                <label>Upload Image </label> <br>
                                <small class="text-danger"> (Recommended size for image 1080 x 345px)</small>
                                <input type="file" id="banner_link" ref="banner_link" v-on:change="handleFileUpload()" class = "form-control">
                                <br>
                            </div>

							<div class = "form-group">
								<img :src="src">
							</div>
                                
                            <input type = "submit" class = "btn btn-primary" value="Submit Request">
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"

export default {
	name: "banner_new",

	data(){
		return{
			vendor: [],
			pending_banner_link: null,
			banner_link:"",
			src: ""
		}
	},

	methods:{
		loadVendor() {
			let token = localStorage.getItem("token");
			let user = JSON.parse(localStorage.getItem("user"));
			let id = this.$route.params.id

			// check if has token
			if (token !== null) {
				token = JSON.parse(token);
				token = token.access_token;

				axios
				.get(axios.lpsURL + "/vendor/getOne/" + id, {
					headers: {
					Authorization: "Bearer " + token
					}
				})
				.then(res => {
					this.vendor = res.data;


					if(this.vendor.pending_banner_link != null){
						this.pending_banner_link = this.vendor.pending_banner_link
						this.loadPendingImage(token, id)
					}

				})
			}
		},

		loadPendingImage(token, id){
			axios.get(axios.lpsURL + "/vendor/banner/" + id + "/show/pending", 
			{
				headers: {
				Authorization: "Bearer " + token
				},
				responseType: 'blob'
			})
			.then(response =>{
				let reader = new FileReader();
				reader.readAsDataURL(response.data); 
				reader.onload = () => {
				this.src = reader.result
				}
			})
		},

		handleFileUpload(){
			this.banner_link = this.$refs.banner_link.files[0];	
        },

		handleSubmit() {
			let token = localStorage.getItem("token");

			// check if has token
			if (token !== null) {
				token = JSON.parse(token);
				token = token.access_token;

				swal({
					icon: 'warning',
					text: 'Are you sure?',
					buttons: ['Cancel', 'Yes']
				}).then((confirm) => {
					if(!confirm){
						return;
					}
					this.upload(token)
				})
				
			}
		},

		upload(token){
			let id = this.$route.params.id
			let formdata = new FormData();

			formdata.append("name", this.vendor.name)
			formdata.append("description", this.vendor.description)
			formdata.append("banner_link", this.banner_link)

			axios
			.post(axios.lpsURL + "/vendor/update/" + id, 
				formdata,
			{
				headers: {
					Authorization: "Bearer " + token,
					"Content-Type": "multipart/form-data"
				}
			})
			.then(res => {
				if(res.data.success){
					swal({
						icon: "success",
						title: "Success",
						text: res.data.message
					})
					.then(ok => {
						this.$router.push("/banner")
					})

				} else{
					swal({
						icon: "error",
						title: "Failed",
						text: res.data.message
					});
				}
			})
		},

	},


	mounted(){
		this.loadVendor()
	}
}
</script>

